export enum NotificationTabKeyEnum {
    browser = 'browser-notifications',
    email = 'email-notifications',
    telegram = 'telegram-notifications',
}
